import React from 'react';
import { EyeOff } from 'lucide-react';
import { DialogProps } from '@radix-ui/react-dialog';

import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import { Question } from 'types/question.types';

import { QuestionPreview } from '../../../components/QuestionPreview';

interface FeedbackPreviewModalProps extends DialogProps {
  questions: (Question | null)[];
}

export const FeedbackPreviewModal = ({
  questions,
  ...props
}: FeedbackPreviewModalProps): React.ReactElement => {
  const validQuestions = questions.filter((q): q is Question => q !== null);

  return (
    <Modal {...props}>
      <ModalContent
        size="md"
        className="tw-flex tw-max-h-[80vh] tw-flex-col"
        data-testid="feedback-preview-modal"
      >
        <ModalHeader className="tw-mb-2">
          <ModalTitle className="tw-text-dark-black">Share your feedback</ModalTitle>
        </ModalHeader>
        <div className="tw-mb-5 tw-flex tw-items-center tw-gap-1 tw-text-sm tw-leading-4 tw-text-primary-grey">
          <EyeOff className="tw-text-primary-grey" size={16} />
          <span>Your responses will be anonymous</span>
        </div>
        <div
          className="
            tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden [&_*]:tw-pointer-events-none [&_*]:tw-cursor-default
          "
        >
          {validQuestions.map((question) => (
            <QuestionPreview key={question.id} question={question} />
          ))}
        </div>
      </ModalContent>
    </Modal>
  );
};
